import React, { useContext } from 'react';
import { ProductContext } from '../../ProductContext';

const SizeGuideToggle = () => {
  const { toggleSizeGuide } = useContext(ProductContext);

  return (
    <div className="d-flex justify-content-end">
      <span
        data-testid={`size-guide-sidebar-toggle`}
        className="label-add body-text-link-small size-guide-trigger"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            toggleSizeGuide(true);
          }
        }}
        onClick={() => {
          toggleSizeGuide(true);
        }}
      >
        Size Guide
      </span>
    </div>
  );
};

export default SizeGuideToggle;
